"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Manually specified split (percentage ratio) for promotion week (PROMO-19 RFC 6).
 *
 * @author Radek Beran
 */


var ManualPromoWeekSplit =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ManualPromoWeekSplit, _DomainObject_1$Domai);

  /**
   * @param promoWeek Year + 'w' + ISO number of promotion week as a string (promotion week starts from Wednesday
   * of corresponding calendar week with the same number and continues up to Tuesday of the next calendar week);
   * e.g.: 2021w03 ({@link PromotionSplitAggregationType#getWeekId} can be used for construction
   * of such a representation).
   * @param splitPercent percentage of splitted volume that should fall into promotion week
   */
  function ManualPromoWeekSplit(promoWeek, splitPercent) {
    var _this;

    _classCallCheck(this, ManualPromoWeekSplit);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ManualPromoWeekSplit).call(this));
    _this.promoWeek = promoWeek;
    _this.splitPercent = splitPercent;
    return _this;
  }
  /**
   * Constructs promoWeek param value as Year + 'w' + ISO number of promotion week.
   *
   * @param yearNumber
   * @param weekNumber
   */


  _createClass(ManualPromoWeekSplit, null, [{
    key: "constructPromoWeek",
    value: function constructPromoWeek(yearNumber, weekNumber) {
      var week = "".concat(weekNumber);

      if (week.length !== 2) {
        week = "0".concat(week);
      }

      return "".concat(yearNumber, "w").concat(week);
    }
    /**
     * Converter from data-dictionary representation.
     */

  }, {
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ManualPromoWeekSplit(mat.promoWeek, mat.splitPercent);
    }
  }]);

  return ManualPromoWeekSplit;
}(DomainObject_1.DomainObject);

exports.ManualPromoWeekSplit = ManualPromoWeekSplit;

ManualPromoWeekSplit.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ManualPromoWeekSplit.name);
  return {
    promoWeek: builder.str('promoWeek'),
    splitPercent: builder.bigNum('splitPercent')
  };
}();